"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _storage = require("@/utils/storage.js");
var _setings = _interopRequireDefault(require("@/layout/navBars/breadcrumb/setings.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'App',
  components: {
    Setings: _setings.default
  },
  provide: function provide() {
    return {
      reload: this.reload
    };
  },
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  watch: {
    // 监听路由 控制侧边栏显示 标记当前顶栏菜单（如需要）
    $route: function $route(to, from) {
      var onRoutes = to.meta.activeMenu ? to.meta.activeMenu : to.meta.path;
      this.$store.commit('menu/setActivePath', onRoutes);
      if (to.name == 'crud_crud') {
        this.$store.state.user.oneLvRoutes.map(function (e) {
          if (e.path === to.path) {
            to.meta.title = e.title;
          }
        });
      }
      //优惠券、秒杀活动
      if (['creatProduct', 'CreatCoupon', 'CreatSeckill', 'CreatTag', 'border', 'articleCreat'].includes(to.name)) {
        var route = to.matched[1].path.split(':')[0];
        this.$store.state.user.oneLvRoutes.map(function (e) {
          if (route.indexOf(e.path) != -1) {
            to.meta.title = "".concat(e.title, " ").concat(to.params.id ? 'ID:' + to.params.id : '');
          }
        });
      }
      //个人中心、修改密码
      if (['MaintainUser'].includes(to.name)) {
        var _route = to.matched[1].path.split(':')[0];
        this.$store.state.user.oneLvRoutes.map(function (e) {
          if (_route.indexOf(e.path) != -1) {
            var params = to.params.type;
            to.meta.title = params === 'users' ? '个人中心' : '修改密码';
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.openSetingsDrawer();
    this.getLayoutThemeConfig();
  },
  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    // 布局配置弹窗打开
    openSetingsDrawer: function openSetingsDrawer() {
      var _this = this;
      this.bus.$on('openSetingsDrawer', function () {
        _this.$refs.setingsRef.openDrawer();
      });
    },
    // 获取缓存中的布局配置
    getLayoutThemeConfig: function getLayoutThemeConfig() {
      if (_storage.Local.get('JavaPlatThemeConfigPrev')) {
        this.$store.dispatch('themeConfig/setThemeConfig', _storage.Local.get('JavaPlatThemeConfigPrev'));
        document.documentElement.style.cssText = _storage.Local.get('JavaPlatThemeConfigStyle');
      } else {
        _storage.Local.set('JavaPlatThemeConfigPrev', this.$store.state.themeConfig.themeConfig);
      }
    }
  },
  destroyed: function destroyed() {
    this.bus.$off('openSetingsDrawer');
  }
};